<template>
    <div class="cabecalho-mobile">
        <div>
            <h1 class="font-semibold text-xl">Checklist</h1>
        </div>
        <div v-if="protocolo" class="flex justify-between flex-wrap">
            <span class="font-semibold ">Nº {{ protocolo }}</span>
        </div>
        <div v-if="placa">
            <div class="text-sm border border-black rounded-md">
                <span class="font-semibold p-2">{{ placa ?? "PLACA" }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import CabecalhoService from '@/services/CabecalhoService';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'Cabecalho',
    setup() {
        return CabecalhoService.setup();
    },
});
</script>

<style scoped>
.cabecalho-mobile {
    @apply h-auto w-full p-4 text-center font-medium flex flex-wrap justify-between items-center bg-azul-padrao text-white;
}
</style>